import { render, staticRenderFns } from "./geo-element.vue?vue&type=template&id=79943ff8&scoped=true&"
import script from "./geo-element.vue?vue&type=script&lang=js&"
export * from "./geo-element.vue?vue&type=script&lang=js&"
import style0 from "./geo-element.vue?vue&type=style&index=0&id=79943ff8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79943ff8",
  null
  
)

export default component.exports